<!--
    Program: CodeMgmtItem.vue
    Author: SDL
    Description: 
    Created: 2020.03.25
-->

<template>
    <div>
        <!-- detail_f tit -->
        <div class="sub_tit mt25">Code Information</div>
        <!-- //detail_f tit -->
        <!--COPY detail_table-->
        <table class="create_table">
            <colgroup>
                <col width="13.5%" />
                <col width="*" />
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>
                        Code Category
                        <em class="txt_mandatory">*</em>
                    </th>
                    <td>
                        <select
                            class="slt_white w100"
                            v-model="selectedCodeIdx"
                            :disabled="mode === MODE.EDIT"
                            @change="selectCodeIdx"
                        >
                            <option
                                v-for="item in availableCodeIdxList"
                                :key="item.CODE_ID"
                                :value="item.CODE_ID"
                            >{{item.CODE_NAME}}</option>
                        </select>
                    </td>
                    <th>
                        Code ID
                        <em class="txt_mandatory">*</em>
                    </th>
                    <td>
                        <input
                            type="text"
                            class="text_input w100"
                            :disabled="mode === MODE.EDIT"
                            maxlength="20"
                            v-regex="'/[^0-9a-zA-Z\-]/g'"
                            v-model="selectedCodeId"
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        Code Name
                        <em class="txt_mandatory">*</em>
                    </th>
                    <td>
                        <input
                            type="text"
                            class="text_input w100"
                            v-model="newCodeName"
                            maxlength="100"
                        />
                    </td>
                    <th>Note</th>
                    <td>
                        <input
                            type="text"
                            class="text_input w100"
                            v-model="newCodeNote"
                            maxlength="100"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        <!--//COPY detail_table-->
        <!-- page btn -->
        <div class="btn_wrap_full topLine">
            <a
                href="javascript:"
                class="btn_white size_full"
                @click="goToList"
            >{{ $t('BUTTON.GLOBAL.LIST') }}</a>
            <div class="btn_right" v-if="mode === MODE.CREATE">
                <a href="javascript:" class="btn_blue" @click="createCode">Create</a>
            </div>
            <div class="btn_right" v-else-if="mode === MODE.EDIT">
                <a href="javascript:" class="btn_blue" @click="updateCode">Save</a>
                <a href="javascript:" class="btn_blue" @click="deleteCode">Delete</a>
            </div>
        </div>
        <!-- //page btn -->
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios'
import qs from 'query-string';
import { SDLUtil, StringUtil } from '@/utils';

const MODULE_NAME = 'HHP CODE MGM ITEM';
const MODULE_URL = `basis/anysvcmobile/code`;

// List of Mode available
const MODE = {
    CREATE: 'create',
    EDIT: 'edit',
};

// List of Events that emit to parent
const EVENT = {
    CREATE: 'create',
    BACK: 'back',
    SAVE: 'save',
    DELETE: 'delete',
};

export default {
    name: 'hhp-code-mgt-item',
    components: {},
    props: {
        mode: { type: String, required: true }, // MODE.CREATE = 'create', MODE.EDIT = 'edit'
        codeIdxList: { type: Array, default: [], required: false },
        codeIdList: { type: [Array, String], required: false },
        codeIdx: { type: String, default: '', required: false },
        codeId: { type: String, default: '', required: false },
        codeName: { type: String, default: '', required: false },
        codeNote: { type: String, default: '', required: false },
    },
    // ['mode', 'codeIdxList', 'codeIdList',
    //     'codeIdx', 'codeId', 'codeName', 'codeNote'],
    computed: {},
    data() {
        return {
            MODE: MODE,
            EVENT: EVENT,

            selectedCodeIdx: '-',
            selectedCodeId: '',

            availableCodeIdxList: [],
            availableCodeIdList: [],

            newCodeName: '',
            newCodeNote: '',
        };
    },
    created() {
        console.log('Component: CodeMgmtItem created. ');
        this.availableCodeIdxList = this.codeIdxList.filter(item => item.CODE_NAME !== 'ALL');
        if (this.mode === MODE.CREATE) {
            this.availableCodeIdxList.unshift({ CODE_ID: '-', CODE_NAME: 'Select' });
        } else {
            // Edit Mode
            if (this.codeIdx) this.selectedCodeIdx = this.codeIdx;
            if (this.codeId) this.selectedCodeId = this.codeId;
            if (this.codeName) this.newCodeName = this.codeName;
            if (this.codeNote) this.newCodeNote = this.codeNote;

            this.fetchCodeIds();
        }
    },
    activated() {
        console.log('Component: CodeMgmtItem activated.');
    },
    deactivated() {
        console.log('Component: CodeMgmtItem deactivated.');
    },
    mounted() {
        console.log('Component: CodeMgmtItem mounted.');
    },
    beforeDestroy() {
        console.log('Component: CodeMgmtItem beforeDestroy.');
    },

    methods: {
        fetchCodeIds() {
            //basis/anysvcmobile/code/?codeInstr=002
            const url = `${SDLUtil.API_URL}/${MODULE_URL}/CodeMgtCodeIdAjax.skp`;
            return axios
                .get(url, {
                    params: { codeInstr: this.selectedCodeIdx },
                })
                .then(resp => {
                    console.log('ITEM', resp);
                    this.availableCodeIdList = resp.data.map(item => item[0]);
                });
        },
        selectCodeIdx() {
            this.fetchCodeIds();
        },
        validateInput(data) {
            // const forbiddenChars = RegExp(/[!@#$%^&*":{}|<>]/, 'g');

            if (typeof data.codeInstr === 'undefined' || data.codeInstr === '-') {
                SDLUtil.alert({ msg: 'Required: Code Category' });
                return false;
            } else {
                // if (forbiddenChars.test(data.codeInstr)) {
                if (StringUtil.hasUnsafeChars(data.codeId)) {
                    SDLUtil.alert({ msg: 'Special chars not allowed in Code Category' });
                    return false;
                }
            }

            if (typeof data.codeId === 'undefined' || data.codeId === '') {
                // alert('Required: 코드ID');
                SDLUtil.alert({ msg: 'Required: Code ID' });
                return false;
            } else {
                // if (forbiddenChars.test(data.codeId)) {
                if (StringUtil.hasUnsafeChars(data.codeId)) {
                    SDLUtil.alert({ msg: 'Special chars not allowed in Code ID' });
                    return false;
                }
            }

            if (typeof data.codeName === 'undefined' || data.codeName === '') {
                // alert('Required: 코드명');
                SDLUtil.alert({ msg: 'Required: Code Name' });
                return false;
            } else {
                // if (forbiddenChars.test(data.codeName)) {
                if (StringUtil.hasUnsafeChars(data.codeName)) {
                    SDLUtil.alert({ msg: 'Special chars not allowed in Code Name' });
                    return false;
                }
            }

            if (typeof data.codeNote === 'undefined' || data.codeNote === '') {
            } else {
                // if (forbiddenChars.test(data.codeNote)) {
                if (StringUtil.hasUnsafeChars(data.codeNote)) {
                    SDLUtil.alert({ msg: 'Special chars not allowed in Note' });
                    return false;
                }
            }

            return true;
        },
        prepFormData() {
            // For Update and Delete
            const formData = {
                codeOpt: this.mode === MODE.CREATE ? 1 : null,
                codeOrinInstr: this.codeIdx,
                codeOrinId: this.codeId,
                codeInstr: this.selectedCodeIdx.trim(),
                codeId: this.selectedCodeId.trim(),
                codeName: this.newCodeName.trim(),
                codeNote: this.newCodeNote.trim(),
            };
            return formData;
        },
        goToList() {
            if (this.mode === MODE.CREATE) {
                const msg = 'Data will be lost.\nWould you like to go to List?';
                const isConfirmed = confirm(msg);
                if (!isConfirmed) return;
            }

            this.$emit(EVENT.BACK);
        },
        createCode() {
            const formData = this.prepFormData();
            const isValid = this.validateInput(formData);
            if (!isValid) return;

            // const msg = "This will CREATE a new code.\nWould you like to continue?";
            // const isConfirmed = confirm(msg);
            // if (!isConfirmed) return;

            const confirmCb = () => {
                SDLUtil.showLoadingBar(true);

                const url = `${SDLUtil.API_URL}/${MODULE_URL}/CodeMgtSaveProc.skp`;
                return axios
                    .post(url, qs.stringify(formData), {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        // params: { searchInfo: 'set' },
                    })
                    .then(resp => {
                        SDLUtil.showLoadingBar(false);
                        const alertParams = {
                            msg: 'Created a new code successfully!',
                            title: 'Create Successful',
                            okLabel: 'GREAT!',
                            onOkEvt: () => {
                                this.$emit(EVENT.CREATE);
                            },
                        };
                        SDLUtil.alert(alertParams);
                    })
                    .catch(err => {
                        Vue.$log.error('Error occured: ', err);
                        SDLUtil.showLoadingBar(false);
                        const alertParams = {
                            msg: 'Failed to create a new code.<br>Check for a duplicate value or a data type.',
                        };
                        SDLUtil.alert(alertParams);
                    });
            };

            const options = {
                title: 'Create Code',
                msg: 'This action will <strong>CREATE</strong> a new code.<br>Would you like to continue?',
                onOkEvt: confirmCb,
            };

            SDLUtil.confirm(options);
        },
        updateCode() {
            const formData = this.prepFormData();
            const isValid = this.validateInput(formData);
            if (!isValid) return;

            const confirmCb = () => {
                SDLUtil.showLoadingBar(true);
                const url = `${SDLUtil.API_URL}/${MODULE_URL}/CodeMgtSaveProc.skp`;
                return axios
                    .post(url, qs.stringify(formData), {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        // params: { searchInfo: 'set' },
                    })
                    .then(resp => {
                        SDLUtil.showLoadingBar(false);
                        const alertParams = {
                            msg: 'Updated the code successfully!',
                            title: 'Successfully Updated',
                            okLabel: 'GREAT!',
                            onOkEvt: () => {
                                this.$emit(EVENT.SAVE);
                            },
                        };
                        SDLUtil.alert(alertParams);
                    })
                    .catch(err => {
                        Vue.$log.error(err);
                        SDLUtil.showLoadingBar(false);
                        const alertParams = {
                            msg: 'Failed to update the code.<br>Check for a duplicate value or a data type.',
                        };
                        SDLUtil.alert(alertParams);
                    });
            };

            const options = {
                title: 'Update Code',
                msg: 'This action will <strong>UPDATE</strong> the current code.<br>Would you like to continue?',
                onOkEvt: confirmCb,
            };

            SDLUtil.confirm(options);
        },
        deleteCode() {
            let formData = this.prepFormData();
            formData.codeName = '';
            formData.codeNote = '';

            const confirmCb = () => {
                SDLUtil.showLoadingBar(true);

                const url = `${SDLUtil.API_URL}/${MODULE_URL}/CodeMgtDelProc.skp`;
                return axios
                    .post(url, qs.stringify(formData), {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        // params: { searchInfo: 'set' },
                    })
                    .then(resp => {
                        SDLUtil.showLoadingBar(false);
                        const alertParams = {
                            msg: 'Deleted the code successfully!',
                            title: 'Successfully Updated',
                            okLabel: 'GREAT!',
                            onOkEvt: () => {
                                this.$emit(EVENT.DELETE);
                            },
                        };
                        SDLUtil.alert(alertParams);
                    })
                    .catch(err => {
                        Vue.$log.error(err);
                        SDLUtil.showLoadingBar(false);
                        const alertParams = {
                            msg: 'Failed to delete the code.',
                        };
                        SDLUtil.alert(alertParams);
                    });
            };

            const options = {
                title: 'Delete Code',
                msg: 'This action will <strong>DELETE</strong> the current code.\nWould you like to continue?',
                onOkEvt: confirmCb,
            };

            SDLUtil.confirm(options);
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/code/CodeMgmtItem.vue